import {DataFetcher} from '@aboutyou/data-fetcher';
import {originClick} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {
  NavigationTree,
  NavigationTreeProps,
} from '../../../features/NavigationTree/NavigationTree';
import {NavigationTreeLoading} from '../../../features/NavigationTree/NavigationTreeLoading';
import {FIRST_PRODUCT_ID_PARAM} from '../../../features/firstProductId/useFirstProductIds';
import {useWishlistTree} from '../hooks/useWishlistTree';

export const WishlistNavigationTree: React.FC<{
  className?: string;
  excludeUrlParams?: string[];
}> = props => {
  return (
    <DataFetcher
      request={useWishlistTree()}
      Error={() => null}
      Loading={NavigationTreeLoading}
      View={NavigationTree}
      viewProps={{
        ...props,
        trackOriginKey: 'category_tree_side' as originClick,
        testId: 'wishlistNavigationTree',
        excludeUrlParams: [
          FIRST_PRODUCT_ID_PARAM,
          'sort',
        ] as NavigationTreeProps['excludeUrlParams'],
      }}
    />
  );
};
